import parseToken from '../lib/bastetjs/utils/parseToken';

export async function getToken() {
  const keycloak = window.kc;
  const current_time = new Date().getTime() / 1000;
  if (keycloak.tokenParsed && current_time > keycloak.tokenParsed['exp']) {
    await keycloak.updateToken(keycloak.timeSkew + 5);
  }
  return keycloak.token || '';
}

export function isLoggedIn(token) {
  /*
    If we use getToken() it'll return a promise, and we want to be able to
    tell if someone is logged in without an async function call
  */
  const keycloak = window.kc;
  const current_time = new Date().getTime() / 1000;
  //If token is passed in, treat it differently than if we rely on keycloak.js refresh token
  return getTokenRacerId(token) > 0
    && (!!token
      || (keycloak.refreshTokenParsed && keycloak.refreshTokenParsed['exp'] > current_time));
}

export function getTokenRacerId(token) {
  const keycloak = window.kc;
  token = token || keycloak.token || '';

  if (!token) {
    return 0;
  }

  const parsed = parseToken.parse(token);
  return parseInt(parsed['athlinks-racer-id'] || 0);
}

export function getClaim(key, token) {
  const keycloak = window.kc;
  token = token || keycloak.token || '';
  return token ? parseToken.parse(token)[key] : '';
}

/**
 * Check if sign up banner should be rendered. Not rendering for mobile
 * @TODO Showing only on ERP for now. Check references to this methods later
 * @return {boolean}
 */
export function shouldShowSignUpBanner() {
  const currentHref = window.location.href;
  const isErrorPage = !!currentHref.match('error');
  return !isLoggedIn() && !isErrorPage;
}



/** WEBPACK FOOTER **
 ** ./utils/isLoggedIn.js
 **/